import Spinner from "../Spinner";
import classNames from "classnames";
import { isEmpty, uniqueId } from "lodash";
import { capitalizeFirstLetterOfWord } from "../../../helpers";
import {
  chevronDownIcon,
  whiteCrossIcon,
  whiteTickIcon,
} from "../../../assets/icons";
import {
  getPipelineSteps,
  getSubStepStatus,
} from "../AppDrawers/drawers.helpers";
import { DEPLOY_STATUSES, EMPTY_STRING } from "../../../constants";
import { ProgressBar } from "../index";
import { useSelector } from "react-redux";
import { selectSelectedApp } from "../../../pages/Applications";
import { selectSelectedDataModel } from "../../../pages/DataModels";
import { useEffect, useState } from "react";

const { SUCCESS, QUEUED, IN_PROGRESS, FAILURE, CANCELLED } = DEPLOY_STATUSES;

const DeployLogRenderer = ({
  setExpandedStep,
  expandedStep,
  logs,
  type,
  shouldShowProgressBar,
  classes,
}) => {
  const selectedApp = useSelector(selectSelectedApp);
  const selectDataModel = useSelector(selectSelectedDataModel);
  const [cloudService, setCloudService] = useState();

  useEffect(() => {
    selectedApp && setCloudService(selectedApp.cloudService);
    selectDataModel && setCloudService(selectDataModel.cloudService);
  }, [selectedApp, selectDataModel]);

  return (
    <>
      <div className="text-gray-50 font-bold text-base text-center rounded-md p-2 ">
        {`${capitalizeFirstLetterOfWord(type)} Deployment Log`}
      </div>
      {shouldShowProgressBar && (
        <div className="mb-2">
          <ProgressBar
            barType="line"
            logs={logs}
            stepsStatus={getPipelineSteps(type, logs, cloudService)}
          />
        </div>
      )}
      <div className={classes}>
        {type &&
          getPipelineSteps(type, logs, cloudService)?.map((each) => (
            <div className="py-3 cursor-pointer flex flex-col" key={each.name}>
              <div
                className="flex justify-between"
                onClick={() =>
                  setExpandedStep(
                    expandedStep === each.name ? EMPTY_STRING : each.name
                  )
                }
              >
                <div className="flex">
                  <Spinner
                    name={each.name}
                    showSpinner={each.status === IN_PROGRESS}
                  >
                    <img
                      src={
                        each.status !== FAILURE && each.status !== CANCELLED
                          ? whiteTickIcon
                          : whiteCrossIcon
                      }
                      alt="status"
                      className={classNames(
                        "w-6 h-6 border-solid rounded-full bg-gray-200 mx-1",
                        {
                          "p-1 !bg-green-400": each.status === SUCCESS,
                          "p-1": each.status === QUEUED,
                          "p-0.5 !bg-red-600":
                            each.status === FAILURE ||
                            each.status === CANCELLED,
                        }
                      )}
                    />
                  </Spinner>
                  <label className="text-sm font-medium text-gray-50 block">
                    {each.name}
                  </label>
                </div>
                {!isEmpty(each.steps) && each.status !== IN_PROGRESS && (
                  <img
                    src={chevronDownIcon}
                    alt="chevron Down"
                    className={classNames("duration-300 cursor-pointer", {
                      "rotate-180": expandedStep === each.name,
                    })}
                    onClick={() =>
                      setExpandedStep(
                        expandedStep === each.name ? EMPTY_STRING : each.name
                      )
                    }
                  />
                )}
              </div>
              {!isEmpty(each.steps) &&
                (each.status === IN_PROGRESS || expandedStep === each.name) &&
                each.steps.map((step) => {
                  const subStepStatus = getSubStepStatus(
                    step.status,
                    step.conclusion
                  );
                  return (
                    <div className="flex pl-8 py-3" key={uniqueId()}>
                      <div>
                        <Spinner
                          name={step.name}
                          showSpinner={step.status === IN_PROGRESS}
                        >
                          <img
                            src={
                              subStepStatus !== FAILURE &&
                              subStepStatus !== CANCELLED
                                ? whiteTickIcon
                                : whiteCrossIcon
                            }
                            alt="status"
                            className={classNames(
                              "w-6 h-6 border-solid rounded-full bg-gray-200 mx-1",
                              {
                                "p-1 !bg-green-400": subStepStatus === SUCCESS,
                                "p-1": subStepStatus === QUEUED,
                                "p-0.5 !bg-red-600":
                                  subStepStatus === FAILURE ||
                                  subStepStatus === CANCELLED,
                              }
                            )}
                          />
                        </Spinner>
                      </div>
                      <label className="text-sm font-medium text-gray-50 block">
                        {step.name}
                      </label>
                    </div>
                  );
                })}
            </div>
          ))}
      </div>
    </>
  );
};

export default DeployLogRenderer;
